import { useAuthProvider } from 'react-admin';
import { AdminNoSecretariatGroup } from 'src/constants/roles';

export class ScheduleManager {
    static isCalendarEventEdit = (): boolean => {
        const authProvider = useAuthProvider();
        return authProvider?.containsRoles([...AdminNoSecretariatGroup]) ?? false;
    };

    static isTooltipEventCardAvailable = (isEventCardContent: boolean, isEventInSameTimeSlot: boolean): boolean => {
        return this.isCalendarEventEdit() || isEventCardContent || isEventInSameTimeSlot;
    };
}
